import React from 'react'
import EditEmp from '../Components/Employee/EditEmp/EditEmp'

const EmployeeEditPage = () => {
  return (
    <div style={{padding:"8px 0px"}} className='NewFormBackColor'>
      <EditEmp/>
    </div>
  )
}

export default EmployeeEditPage
